import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Card } from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../../components/Component";
import { Row, Col } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Modal, ModalBody } from "reactstrap";
import contractorsApis from "../../../api/master/contractors";
import FormInput from "../../form-components/InputComponent";
import PhoneNumberInput from "../../form-components/PhoneNumberInput";
import FormatDate from "../DateFormater";
import usersApis from "../../../api/master/users";
import FormSelect from "../../form-components/SelectComponent";
import { FormProvider, useForm } from "react-hook-form";
import FormDatePicker from "../../form-components/DatePicker";
import { useSelector } from "react-redux";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import sites from "../../../api/master/sites";
import { Switch } from "antd";
import dayjs from "dayjs";
import GstinVerificationModal from "../../../components/GstinVerificationModal";

interface Document {
  docId: number;
  fileName: string;
  filePath: string;
  module: string;
  moduleFileType: string;
}

interface SelectOptions {
  label: string;
  value: string;
}
interface ModifiedSections {
  contractorInformation: boolean;
  contractorProfile: boolean;
  EmergencyResponseAndContingencyPlan: boolean;
  ScopeOfWorkComplianceAndCertifications: boolean;
}

const ViewClientDetails: FC = () => {
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);
  const [sm, updateSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  let { siteId } = useParams();
  const [data, setData] = useState<any>();
  const [modalGI, setGIModal] = useState<any>(false);
  const [modalEditBlockName, setModalEditBlockName]: any = useState("");
  const [formData, setFormData]: any = useState({
    companyName: "",
    contactPerson: "",
    email: "",
    phoneNumber: "",
    mailingAddressLine1: "",
    businessDescription: "",
    yearsInBusiness: "",
    applicationAccess: "",
    regulatoryCompliance: "",
    insuranceCoverage: "",
    docsUpload: "",
    projectRequirements: "",
    specifications: "",
    // docsUpload: "",
    billingRates: "",
    // docsUpload: "",
    contractTerms: "",
    insuranceRequirements: "",
    // docsUpload: "",
    qualityAssurancePlan: "",
    inspectionAndAcceptanceCriteria: "",
    docsUpload4: "",
    environmentalCompliance: "",
    wasteManagementProcedures: "",
    docsUpload2: "",
    emergencyContactPerson: "",
    emergencyContactNumber: "",
    emergencyProcedures: "",
    docsUpload3: "",
    disputeResolutionProcess: "",
    docsUpload5: "",
  });

  const [countries, setCountries] = useState<SelectOptions[]>([]);
  const [states, setStates] = useState<SelectOptions[]>([]);
  const [districtOptions, setDistrictOptions] = useState<SelectOptions[]>([]);
  const [appAccess, setAppAccess] = useState(false);
  const [isUpdatingAccess, setIsUpdatingAccess] = useState(false);

  const [modifiedSections, setModifiedSections] = useState<ModifiedSections>({
    contractorInformation: false,
    contractorProfile: false,
    EmergencyResponseAndContingencyPlan: false,
    ScopeOfWorkComplianceAndCertifications: false,
  });
  // gst modal
  const [isGstVerified, setIsGstVerified] = useState(false);
  const [previousBusinessType, setPreviousBusinessType] = useState("");
  const [gstinModal, setGstinModal] = useState(false);

  const methods = useForm();

  const {
    handleSubmit,
    setValue,
    watch,
    trigger,
  } = methods;

  const businessType = watch("bussinessType");

  useEffect(() => {
    if (businessType === "registered") {
      setValue("applicationAccess", "true");
    }
    if (businessType === "unregistered") {
      setValue("gstin", "");
    }
  }, [businessType]);

  const [docs, setDocs] = useState<Document[]>([]);
  const [workingSites, setWorkingSites] = useState<SelectOptions[]>([]);
  const getCountries = async () => {
    try {
      const _countries = await usersApis.getCountrys();
      if (_countries.status) {
        if (_countries.data.length > 0) {
          const transformedData = _countries.data.map((item: any) => ({
            value: item.countryId.toString(),
            label: item.countryName,
          }));
          setCountries(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const fetchStatesByCountry = async (countryId: string, stateId?: string) => {
    try {
      const data = await usersApis.getStatesByCountry(countryId);
      const stateOptions = data?.data?.map((state: any) => ({
        value: state.stateId.toString(),
        label: state.stateName,
      }));
      if (stateOptions.length > 0) setStates(stateOptions);
      if (stateId) {
        const state = stateOptions.find(
          (state: SelectOptions) => state.value === stateId
        );
        if (!state) {
          return;
        }
        // setValue("state", state.value);
      }
    } catch (error) {}
  };
  const getDistricts = async (stateID: any) => {
    try {
      const districts = await usersApis.getDistrictsByState(stateID);
      console.log(districts);
      if (districts.status) {
        if (districts.data.length > 0) {
          const transformedData = districts.data.map((item: any) => ({
            value: item.districtId.toString(),
            label: item.districtName,
          }));
          setDistrictOptions(transformedData);
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const fetchWorkingSites = async () => {
    try {
      const { data, status, message } = await sites.fetchSites();
      if (status) {
        setWorkingSites(
          data.map((item: any) => ({
            label: item.name,
            value: item.siteID,
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };

  // function to change the design view under 990 px
  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    document
      .getElementsByClassName("nk-header")[0]
      .addEventListener("click", function () {
        updateSm(false);
      });
    const id = siteId;
    console.log("id", id);
    if (id !== undefined || null || "") {
      fetchContractorData(id);
      fetchWorkingSites();
      getCountries();
    }
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, [siteId]);

  // const openEditModal = (modalEditBlockName: any) => {
  //   setModalEditBlockName(modalEditBlockName);
  //   setGIModal(true);
  // };

  const openEditModal = (modalEditBlockName: keyof ModifiedSections) => {
    setModalEditBlockName(modalEditBlockName);
    setGIModal(true);

    // reset(formData);
    
    // Reset modified sections tracking
    setModifiedSections({
      contractorInformation: false,
      contractorProfile: false,
      EmergencyResponseAndContingencyPlan: false,
      ScopeOfWorkComplianceAndCertifications: false,
    });

    // Set the current section as being modified
    setModifiedSections((prev) => ({
      ...prev,
      [modalEditBlockName]: true,
    }));
  };

  // Create a function to get only the fields that belong to a specific section
  const getSectionFields = (section: keyof ModifiedSections, formData: any) => {
    const sectionFields: any = {};

    const fieldMappings = {
      contractorInformation: [
        "referenceID",
        "contractorType",
        "companyName",
        "contactPerson",
        "siteAccessibility",
        "email",
        "phoneNumber",
        "country",
        "state",
        "district",
        "city",
        "area",
        "mailingAddressLine1",
        "pincode",
        "yearsInBusiness",
        "applicationAccess",
      ],
      contractorProfile: [
        "bussinessType",
        "cin",
        "gstin",
        "incorporationDate",
        "pan",
        "lastFYTurnover",
      ],
      EmergencyResponseAndContingencyPlan: [
        "emergencyContactPerson",
        "emergencyContactNumber",
        "emergencyProcedures",
      ],
      ScopeOfWorkComplianceAndCertifications: [
        "regulatoryCompliancedocsUpload",
        "licensesAndPermitsdocsUpload",
        "insuranceCoveragedocsUpload",
        "ScopeofWorkdocsUpload",
        "BillingandPaymentTermsdocsUpload",
        "contractTermsdocsUpload",
        "environmentalCompliancedocsUpload",
        "wasteManagementProceduresdocsUpload",
        "qualityAssurancePlandocsUpload",
        "disputeResolutionProcessdocsUpload",
      ],
    };

    fieldMappings[section].forEach((field) => {
      if (formData[field] !== undefined) {
        sectionFields[field] = formData[field];
      }
    });

    return sectionFields;
  };
  // Check if business type changed from unregistered to registered
  useEffect(() => {
    if (
      previousBusinessType === "unregistered" &&
      businessType === "registered" &&
      !isGstVerified
    ) {
      setGstinModal(true);
    }
    setPreviousBusinessType(businessType);
  }, [businessType]);

  useEffect(() => {
    if (data) {
      const gstVerified = !!data.gstin && !!data.pan;
      setIsGstVerified(gstVerified);
      setPreviousBusinessType(data.bussinessType || "");
    }
  }, [data]);

  const submitUpdates = async (submitData: any) => {
    if (!modalEditBlockName) return;

    if (
      previousBusinessType === "unregistered" &&
      businessType === "registered" &&
      !isGstVerified
    ) {
      Swal.fire({
        title: "Validation Error",
        text: "Please upload GST file to proceed.",
        icon: "error",
      });
      setGstinModal(true);
      return;
    }

    const sectionData = getSectionFields(modalEditBlockName, submitData);

    // Exclude applicationAccess explicitly
    if ("applicationAccess" in sectionData) {
      delete sectionData.applicationAccess;
    }

    if (
      previousBusinessType === "unregistered" &&
      businessType === "registered"
    ) {
      if (data.pan && sectionData.pan === data.pan) {
        delete sectionData.pan;
      }
    }

    if (businessType === "registered") {
      if ("pan" in sectionData) {
        delete sectionData.pan;
      }
    }

    // Get modified fields only for this section
    const getModifiedFields = (original: any, updated: any) => {
      const modified: any = {};
      Object.keys(updated).forEach((key) => {
        // Skip file fields - they will be handled separately
        if (key === "emergencyProcedures") return;

        if (typeof updated[key] === "object" && updated[key] !== null) {
          if (JSON.stringify(updated[key]) !== JSON.stringify(original[key])) {
            modified[key] = updated[key];
          }
        } else {
          if (updated[key] !== original[key]) {
            modified[key] = updated[key];
          }
        }
      });
      return modified;
    };

    const modifiedFields = getModifiedFields(data, sectionData);

    if (businessType === "registered" && "pan" in modifiedFields) {
      delete modifiedFields.pan;
    }

    const { emergencyProcedures } = submitData;
    const filesData: any[] = [];
    const files: any[] = [];
    const deletedFileData: any[] = [];
    const formData: any = new FormData();

    // Handle file upload
    if (emergencyProcedures && emergencyProcedures[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "emergencyProcedures",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(emergencyProcedures[0]);

      const previousDoc = docs.filter(
        (document: any) => document.moduleFileType === "emergencyProcedures"
      );

      if (previousDoc.length > 0) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    // Handle text input for emergencyProcedures (if it's a string)
    else if (
      typeof emergencyProcedures === "string" &&
      emergencyProcedures.trim() !== ""
    ) {
      modifiedFields.emergencyProcedures = emergencyProcedures.trim();
    }

    formData.append("contractorData", JSON.stringify(modifiedFields));
    formData.append(
      "filesData",
      JSON.stringify({
        newfiledata: filesData,
        deletedFileData: deletedFileData,
        updatedFileData: [],
      })
    );

    files.forEach((file) => {
      formData.append(`files`, file);
    });

    try {
      const { status, message } = await contractorsApis.updateContractorById(
        siteId,
        formData
      );

      if (status) {
        Swal.fire("Updated!", "Client has been updated", "success");
        setGIModal(false);
        fetchContractorData(siteId);
      } else {
        let errorList: string[] = [];

        if (typeof message === "string") {
          errorList.push(message);
        } else if (Array.isArray(message)) {
          message.forEach((errObj: any) => {
            if (Array.isArray(errObj.errors)) {
              errObj.errors.forEach((errMsg: string) => {
                errorList.push(`${errObj.field.toUpperCase()}: ${errMsg}`);
              });
            }
          });
        }

        Swal.fire({
          title: "Update Failed!",
          html: `<ul style="text-align:left; color:red;">
          ${errorList.map((err) => `<li>${err}</li>`).join("")}
        </ul>`,
          icon: "error",
        });
      }
    } catch (error: any) {
      Swal.fire("Error", error.message || "Failed to update", "error");
    }
  };

  const uploadDocsSubmit = async (data: any) => {
    const {
      regulatoryCompliancedocsUpload,
      licensesAndPermitsdocsUpload,
      insuranceCoveragedocsUpload,
      ScopeofWorkdocsUpload,
      BillingandPaymentTermsdocsUpload,
      contractTermsdocsUpload,
      environmentalCompliancedocsUpload,
      wasteManagementProceduresdocsUpload,
      qualityAssurancePlandocsUpload,
      disputeResolutionProcessdocsUpload,
    } = data;

    const filesData = [];
    const files = [];
    const deletedFileData: any = [];
    const formData: any = new FormData();
    if (regulatoryCompliancedocsUpload && regulatoryCompliancedocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "regulatoryCompliancedocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(regulatoryCompliancedocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "regulatoryCompliancedocsUpload"
      );

      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (licensesAndPermitsdocsUpload && licensesAndPermitsdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "licensesAndPermitsdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(licensesAndPermitsdocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "licensesAndPermitsdocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (insuranceCoveragedocsUpload && insuranceCoveragedocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "insuranceCoveragedocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(insuranceCoveragedocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "insuranceCoveragedocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (ScopeofWorkdocsUpload && ScopeofWorkdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "ScopeofWorkdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(ScopeofWorkdocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) => document.moduleFileType == "ScopeofWorkdocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (
      BillingandPaymentTermsdocsUpload &&
      BillingandPaymentTermsdocsUpload[0]
    ) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "BillingandPaymentTermsdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(BillingandPaymentTermsdocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "BillingandPaymentTermsdocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (contractTermsdocsUpload && contractTermsdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "contractTermsdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(contractTermsdocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) => document.moduleFileType == "contractTermsdocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (
      environmentalCompliancedocsUpload &&
      environmentalCompliancedocsUpload[0]
    ) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "environmentalCompliancedocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(environmentalCompliancedocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "environmentalCompliancedocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (
      wasteManagementProceduresdocsUpload &&
      wasteManagementProceduresdocsUpload[0]
    ) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "wasteManagementProceduresdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(wasteManagementProceduresdocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "wasteManagementProceduresdocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (qualityAssurancePlandocsUpload && qualityAssurancePlandocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "qualityAssurancePlandocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(qualityAssurancePlandocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "qualityAssurancePlandocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    if (
      disputeResolutionProcessdocsUpload &&
      disputeResolutionProcessdocsUpload[0]
    ) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "disputeResolutionProcessdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(disputeResolutionProcessdocsUpload[0]);
      const previousDoc = docs.filter(
        (document: any) =>
          document.moduleFileType == "disputeResolutionProcessdocsUpload"
      );
      if (previousDoc) {
        previousDoc.forEach((doc: any) => {
          deletedFileData.push({
            docId: doc.docId,
          });
        });
      }
    }
    delete data.regulatoryCompliancedocsUpload;
    delete data.licensesAndPermitsdocsUpload;
    delete data.insuranceCoveragedocsUpload;
    delete data.ScopeofWorkdocsUpload;
    delete data.BillingandPaymentTermsdocsUpload;
    delete data.contractTermsdocsUpload;
    delete data.environmentalCompliancedocsUpload;
    delete data.wasteManagementProceduresdocsUpload;
    delete data.qualityAssurancePlandocsUpload;
    delete data.disputeResolutionProcessdocsUpload;
    methods.setValue("regulatoryCompliancedocsUpload", null);
    methods.setValue("licensesAndPermitsdocsUpload", null);
    methods.setValue("insuranceCoveragedocsUpload", null);
    methods.setValue("ScopeofWorkdocsUpload", null);
    methods.setValue("BillingandPaymentTermsdocsUpload", null);
    methods.setValue("contractTermsdocsUpload", null);
    methods.setValue("environmentalCompliancedocsUpload", null);
    methods.setValue("wasteManagementProceduresdocsUpload", null);
    methods.setValue("qualityAssurancePlandocsUpload", null);
    methods.setValue("disputeResolutionProcessdocsUpload", null);

    // formData.append("contractorData", JSON.stringify(data));
    formData.append("contractorData", JSON.stringify({}));
    formData.append(
      "filesData",
      JSON.stringify({
        newfiledata: filesData,
        deletedFileData: deletedFileData,
        updatedFileData: [],
      })
    );
    files.forEach((file) => {
      formData.append(`files`, file);
    });
    const { status, message } = await contractorsApis.updateContractorById(
      siteId,
      formData
    );
    if (status) {
      Swal.fire("Updated!", "Client has been updated", "success");
      setGIModal(false);
      fetchContractorData(siteId);
      //   navigate(`/clients`);
    } else {
      Swal.fire("Failed!", message, "error");
    }
  };

  const handleApplicationAccessChange = async (checked: boolean) => {
    if (!siteId) {
      Swal.fire("Error", "Client ID is missing", "error");
      return;
    }

    setIsUpdatingAccess(true);
    try {
      let response;

      if (checked) {
        response = await contractorsApis.allowApplicationAccess(siteId);
      } else {
        response = await contractorsApis.removeApplicationAccess(siteId);
      }

      if (response.status) {
        setAppAccess(checked);
        if (data) {
          setData({
            ...data,
            applicationAccess: checked ? "true" : "false",
          });
        }
        Swal.fire(
          "Success!",
          `Application access ${checked ? "allowed" : "removed"} successfully`,
          "success"
        );
      } else {
        setAppAccess(!checked);
        Swal.fire(
          "Error",
          response.message || "Failed to update application access",
          "error"
        );
      }
    } catch (error: any) {
      setAppAccess(!checked);
      Swal.fire(
        "Error",
        error.message || "Failed to update application access",
        "error"
      );
    } finally {
      setIsUpdatingAccess(false);
    }
  };

  const fetchContractorData = async (id: any) => {
    try {
      const { data, status } =
        await contractorsApis.fetchContractorById(id);
      // console.log("status", data);
      if (status) {
        // console.log("status", data);
        // const newData = data;
        const parseDate = (dateString: string) => {
          if (!dateString) return null;
          if (dateString.includes("/")) {
            const [day, month, year] = dateString.split("/");
            return dayjs(`${year}-${month}-${day}`);
          }
          return dayjs(dateString);
        };
        const newData = {
          ...data,
          incorporationDate: data.dateOfRegistration
            ? parseDate(data.dateOfRegistration)
            : data.incorporationDate,
        };
        setDocs(data.docs);
        setData(newData); // Update data with fetched response
        setValue(
          "incorporationDate",
          newData.incorporationDate
            ? parseDate(newData.incorporationDate)
            : null
        );

        // Fix: Handle both boolean true/false and string "true"/"false"
        const applicationAccessValue = newData.applicationAccess;
        const isAppAccess =
          applicationAccessValue === true ||
          applicationAccessValue === "true" ||
          applicationAccessValue === 1 ||
          applicationAccessValue === "1";

        console.log("Calculated appAccess:", isAppAccess);
        setAppAccess(isAppAccess);

        fetchStatesByCountry(data.country, newData.state);
        getDistricts(data.state);
        setFormData({
          companyName: newData.companyName,
          contactPerson: newData.contactPerson,
          email: newData.email,
          phoneNumber: newData.phoneNumber,
          mailingAddressLine1: newData.mailingAddressLine1,
          businessDescription: newData.businessDescription,
          yearsInBusiness: newData.yearsInBusiness,
          applicationAccess: newData.applicationAccess,
          cin: newData.cin,
          creditDays: newData.creditDays,
          businessType: newData.businessType,
          incorporationDate: newData.incorporationDate,
          pan: newData.pan,
          gstin: newData.gstin,
          lastFYTurnover: newData.lastFYTurnover,
        });
        setValue("referenceID", newData.referenceID);
        setValue("contractorType", newData.contractorType);
        setValue("companyName", newData.companyName);
        setValue("contactPerson", newData.contactPerson);
        setValue(
          "siteAccessibility",
          data.siteAccessibility.map((item: any) => item.siteID)
        );
        setValue("email", newData.email);
        setValue("phoneNumber", newData.phoneNumber);
        setValue("country", newData.country);
        setValue("state", newData.state);
        setValue("district", newData.district);
        setValue("city", newData.city);
        setValue("area", newData.area);
        setValue("pincode", newData.pincode);
        setValue("mailingAddressLine1", newData.mailingAddressLine1);
        setValue("yearsInBusiness", newData.yearsInBusiness);
        setValue("applicationAccess", newData.applicationAccess);
        setValue("bussinessType", newData.bussinessType);
        // setValue("incorporationDate", moment(newData.incorporationDate));
        setValue(
          "incorporationDate",
          newData.incorporationDate ? dayjs(newData.incorporationDate) : null
        );
        setValue("pan", newData.pan);
        setValue("gstin", newData.gstin);
        setValue("cin", newData.cin);
        setValue("lastFYTurnover", newData.lastFYTurnover);
        setValue("emergencyContactPerson", newData.emergencyContactPerson);
        setValue("emergencyContactNumber", newData.emergencyContactNumber);
      }
    } catch (err: any) {
      Swal.fire(
        "Failed!",
        err.response?.data?.message || "Unknown error",
        "error"
      );
    }
  };

  return (
    <>
      <React.Fragment>
        <Head title="Client Details"></Head>
        <Content>
          {data && (
            <>
              <BlockHead size="sm">
                <BlockBetween className="g-3">
                  <BlockHeadContent>
                    <BlockTitle page>
                      Client Details -{" "}
                      <strong className="text-primary small">
                        {data["contactPerson"]}
                      </strong>
                    </BlockTitle>
                    <BlockDes className="text-soft">
                      <ul className="list-inline">
                        {/* <li>
                                                Site ID: <span className="text-base">{data.siteID}</span>
                                            </li> */}
                        <li>
                          Created At:{" "}
                          <span className="text-base">
                            {FormatDate(data.createdDate)}
                          </span>
                        </li>
                      </ul>
                    </BlockDes>
                  </BlockHeadContent>
                  <BlockHeadContent>
                    {/* {submitEditData && (
                    <Button
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                      style={{ marginRight: "10px" }}
                      onClick={() => submitUpdates()}
                    >
                      <Icon name="check-round-cut"></Icon>
                      <span>Submit Updates</span>
                    </Button>
                  )} */}

                    {/* <Button outline className="bg-white d-none d-sm-inline-flex" style={{ marginRight: "10px" }} onClick={() => openEditModal()}>
                                        <Icon name="edit-alt-fill"></Icon>
                                        <span>Edit</span>
                                    </Button> */}
                    <Link to={`${process.env.PUBLIC_URL}/clients`}>
                      <Button
                        outline
                        className="bg-white d-none d-sm-inline-flex"
                      >
                        <Icon name="arrow-left"></Icon>
                        <span>Back</span>
                      </Button>
                      <Button
                        outline
                        className="btn-icon bg-white d-inline-flex d-sm-none"
                      >
                        <Icon name="arrow-left"></Icon>
                      </Button>
                    </Link>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>

              <Block>
                <Row className="gy-5">
                  <Col
                    lg="5"
                    sm={undefined}
                    md={undefined}
                    xxl={undefined}
                    size={undefined}
                    className={undefined}
                  >
                    <BlockHead>
                      <BlockBetween>
                        <BlockHeadContent>
                          <BlockTitle tag="h5">General Information</BlockTitle>
                          <p>Name, Address etc.</p>
                        </BlockHeadContent>
                        <BlockHeadContent>
                          {allowedActions?.edit ? (
                            <Button
                              outline
                              className="d-none d-sm-inline-flex"
                              style={{ marginRight: "10px" }}
                              onClick={() =>
                                openEditModal("contractorInformation")
                              }
                            >
                              <Icon name="edit-alt-fill"></Icon>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </BlockHeadContent>
                      </BlockBetween>
                    </BlockHead>
                    <Card className="card-bordered">
                      <ul className="data-list is-compact">
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Client ID</div>
                            <div className="data-value">{data.referenceID}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Client Type</div>
                            <div className="data-value">
                              {data.contractorType}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Client Name</div>
                            <div className="data-value">{data.companyName}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Contact Person</div>
                            <div className="data-value">
                              {data.contactPerson}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Site Accessibility</div>
                            <div className="data-value">
                              {data.siteAccessibility
                                .map(
                                  (siteAccessibility: any) =>
                                    siteAccessibility.siteName
                                )
                                .join(", ")}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Email Address</div>
                            <div className="data-value">{data.email}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Phone Number</div>
                            <div className="data-value">{data.phoneNumber}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Country</div>
                            <div className="data-value">
                              {
                                countries.find((c) => c.value == data.country)
                                  ?.label
                              }
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">State</div>
                            <div className="data-value">
                              {states.find((s) => s.value == data.state)?.label}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">District</div>
                            <div className="data-value">
                              {
                                districtOptions.find(
                                  (s) => s.value == data.district
                                )?.label
                              }
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">City</div>
                            <div className="data-value">{data.city}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Area</div>
                            <div className="data-value">{data.area}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Address Line 1</div>
                            <div className="data-value">
                              {data.mailingAddressLine1}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Zip/Pincode</div>
                            <div className="data-value">{data.pincode}</div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">Years in Business</div>
                            <div className="data-value">
                              {data.yearsInBusiness}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">
                              Application Accessibility
                            </div>
                            <div className="data-value">
                              <Switch
                                checked={appAccess}
                                onChange={handleApplicationAccessChange}
                                loading={isUpdatingAccess}
                                disabled={
                                  isUpdatingAccess || !allowedActions?.edit
                                }
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </Card>
                  </Col>

                  <Col
                    lg="7"
                    sm={undefined}
                    md={undefined}
                    xxl={undefined}
                    size={undefined}
                    className={undefined}
                  >
                    <BlockHead>
                      <BlockBetween>
                        <BlockHeadContent>
                          <BlockTitle tag="h5">Legal Information</BlockTitle>
                          <p>BusinessType, PAN, GSTIN etc.</p>
                        </BlockHeadContent>
                        <BlockHeadContent>
                          {allowedActions?.edit ? (
                            <Button
                              outline
                              className="d-none d-sm-inline-flex"
                              style={{ marginRight: "10px" }}
                              onClick={() => openEditModal("contractorProfile")}
                            >
                              <Icon name="edit-alt-fill"></Icon>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </BlockHeadContent>
                      </BlockBetween>
                    </BlockHead>
                    <Card className="card-bordered">
                      <ul className="data-list is-compact">
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">BusinessType</div>
                            <div className="data-value">
                              {data.bussinessType || "N/A"}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">CIN</div>
                            <div className="data-value">
                              {data.cin || "N/A"}
                            </div>
                          </div>
                        </li>
                        {data.bussinessType == "registered" && (
                          <>
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">
                                  Incorporation Date
                                </div>
                                <div className="data-value">
                                  {/* {FormatDate(data.incorporationDate || "N/A")} */}
                                  {data.incorporationDate
                                    ? dayjs(data.incorporationDate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : "N/A"}
                                </div>
                              </div>
                            </li>
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">PAN</div>
                                <div className="data-value">
                                  {data.pan || "N/A"}
                                </div>
                              </div>
                            </li>
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">GSTIN</div>
                                <div className="data-value">
                                  {data.gstin || "N/A"}
                                </div>
                              </div>
                            </li>
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">
                                  Last FY Turn over
                                </div>
                                <div className="data-value">
                                  {data.lastFYTurnover || "N/A"}
                                </div>
                              </div>
                            </li>
                          </>
                        )}
                      </ul>
                    </Card>

                    <BlockHead>
                      <BlockBetween>
                        <BlockHeadContent>
                          <BlockTitle tag="h5">
                            Emergency Response and Contingency Plans
                          </BlockTitle>
                          <p>
                            Here are the Emergency Response and Contingency
                            Plans.
                          </p>
                        </BlockHeadContent>
                        <BlockHeadContent>
                          {allowedActions?.edit ? (
                            <Button
                              outline
                              className="d-none d-sm-inline-flex"
                              style={{ marginRight: "10px" }}
                              onClick={() =>
                                openEditModal(
                                  "EmergencyResponseAndContingencyPlan"
                                )
                              }
                            >
                              <Icon name="upload"></Icon>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </BlockHeadContent>
                      </BlockBetween>
                    </BlockHead>

                    <Card className="card-bordered">
                      <ul className="data-list is-compact">
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">
                              Emergency Contact Person
                            </div>
                            <div className="data-value">
                              {data.emergencyContactPerson}
                            </div>
                          </div>
                        </li>
                        <li className="data-item">
                          <div className="data-col">
                            <div className="data-label">
                              Emergency Contact Number
                            </div>
                            <div className="data-value">
                              {data.emergencyContactNumber}
                            </div>
                          </div>
                        </li>
                        {docs?.map((document: any) => {
                          if (document.moduleFileType !== "emergencyProcedures")
                            return <></>;
                          return (
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">
                                  {document.moduleFileType}
                                </div>
                                <span className="data-value">
                                  <a
                                    href={document.filePath}
                                    target="_blank"
                                    style={{
                                      pointerEvents: "auto",
                                      cursor: "default",
                                    }}
                                  >
                                    {document.fileName}
                                  </a>
                                </span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </Card>

                    <BlockHead>
                      <BlockBetween>
                        <BlockHeadContent>
                          <BlockTitle tag="h5">
                            Scope of Work Compliance and Certifications
                          </BlockTitle>
                          <p>Some more Other details.</p>
                        </BlockHeadContent>
                        <BlockHeadContent>
                          {allowedActions?.edit ? (
                            <Button
                              outline
                              className="d-none d-sm-inline-flex"
                              style={{ marginRight: "10px" }}
                              onClick={() =>
                                openEditModal(
                                  "ScopeOfWorkComplianceAndCertifications"
                                )
                              }
                            >
                              <Icon name="upload"></Icon>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </BlockHeadContent>
                        <BlockHeadContent>
                          <Button
                            outline
                            className="d-none d-sm-inline-flex"
                            style={{ marginRight: "10px" }}
                            title="Not Avilable for now"
                            disabled
                          ></Button>
                        </BlockHeadContent>
                      </BlockBetween>
                    </BlockHead>

                    <Card className="card-bordered">
                      {/* {JSON.stringify(document)} */}
                      <ul className="data-list is-compact">
                        {docs?.map((document: any) => {
                          if (document.moduleFileType == "emergencyProcedures")
                            return <></>;
                          return (
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">
                                  {document.moduleFileType}
                                </div>
                                <span className="data-value">
                                  <a
                                    href={document.filePath}
                                    target="_blank"
                                    style={{
                                      pointerEvents: "auto",
                                      cursor: "default",
                                    }}
                                  >
                                    {document.fileName}
                                  </a>
                                </span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </Card>
                  </Col>
                </Row>
              </Block>

              <Modal
                isOpen={modalGI}
                className="modal-dialog-centered"
                size="xl"
                toggle={() => setGIModal(false)}
                backdrop="static"
              >
                <a
                  href="#dropdownitem"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setGIModal(false);
                  }}
                  className="close"
                >
                  <Icon name="cross-sm"></Icon>
                </a>
                {modalEditBlockName ===
                  "ScopeOfWorkComplianceAndCertifications" && (
                  <ModalBody>
                    <div className="">
                      <div className="nk-modal-head">
                        <h5 className="title">
                          {/* Edit Emergency Response and Contingency Plans */}
                          Edit Scope of Work Compliance and Certifications
                        </h5>
                      </div>
                      <div className="nk-tnx-details mt-sm-3">
                        <FormProvider {...methods}>
                          <form
                            className="content clearfix"
                            onSubmit={handleSubmit(uploadDocsSubmit)}
                          >
                            <Row className="gy-4">
                              <Col md="4">
                                <FormInput
                                  name="regulatoryCompliancedocsUpload"
                                  label="Regulatory Compliance Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {regulatoryCompliancedocsUploadWatch && (
                                <div>
                                  {regulatoryCompliancedocsUploadWatch[0]?.name}
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "regulatoryCompliancedocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="licensesAndPermitsdocsUpload"
                                  label="Licenses And Permits Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {licensesAndPermitsdocsUploadWatch && (
                                <div>
                                  {licensesAndPermitsdocsUploadWatch[0]?.name}
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "licensesAndPermitsdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="insuranceCoveragedocsUpload"
                                  label="Insurance Coverage Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {insuranceCoveragedocsUploadWatch && (
                                <div>
                                  {insuranceCoveragedocsUploadWatch[0]?.name}
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "insuranceCoveragedocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="ScopeofWorkdocsUpload"
                                  label="Scope of Work Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                  // disabled={action === "view"}
                                />
                                {/* {ScopeofWorkdocsUploadWatch && (
                                <div>{ScopeofWorkdocsUploadWatch[0]?.name}</div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "ScopeofWorkdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="BillingandPaymentTermsdocsUpload"
                                  label="Billing and Payment Terms Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {BillingandPaymentTermsdocsUploadWatch && (
                                <div>
                                  {
                                    BillingandPaymentTermsdocsUploadWatch[0]
                                      ?.name
                                  }
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "BillingandPaymentTermsdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="contractTermsdocsUpload"
                                  label="Contract Terms Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {contractTermsdocsUploadWatch && (
                                <div>
                                  {contractTermsdocsUploadWatch[0]?.name}
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "contractTermsdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="environmentalCompliancedocsUpload"
                                  label="Environmental Compliance Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {environmentalCompliancedocsUploadWatch && (
                                <div>
                                  {
                                    environmentalCompliancedocsUploadWatch[0]
                                      ?.name
                                  }
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "environmentalCompliancedocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="wasteManagementProceduresdocsUpload"
                                  label="Waste Management Procedures Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {wasteManagementProceduresdocsUploadWatch && (
                                <div>
                                  {
                                    wasteManagementProceduresdocsUploadWatch[0]
                                      ?.name
                                  }
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "wasteManagementProceduresdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="qualityAssurancePlandocsUpload"
                                  label="Quality Assurance Plan Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {qualityAssuranceProceduresdocsUploadWatch && (
                                <div>
                                  {
                                    qualityAssuranceProceduresdocsUploadWatch[0]
                                      ?.name
                                  }
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "qualityAssuranceProceduresdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                              <Col md="4">
                                <FormInput
                                  name="disputeResolutionProcessdocsUpload"
                                  label="Dispute Resolution Process Docs Upload"
                                  type="file"
                                  placeholder="Docs Upload"
                                />
                                {/* {disputeResolutionProcessdocsUploadWatch && (
                                <div>
                                  {
                                    disputeResolutionProcessdocsUploadWatch[0]
                                      ?.name
                                  }
                                </div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "disputeResolutionProcessdocsUpload"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                            </Row>
                            <Row className="gy-4 mt-1">
                              <Col size="12">
                                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                  <li>
                                    <Button
                                      color="primary"
                                      size="lg"
                                      // onClick={() => submitForm()}
                                    >
                                      Update
                                    </Button>
                                  </li>
                                  <li>
                                    <a
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setGIModal(false);
                                      }}
                                      className="link link-light"
                                    >
                                      Cancel
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </form>
                        </FormProvider>
                      </div>
                    </div>
                  </ModalBody>
                )}
                {modalEditBlockName ===
                  "EmergencyResponseAndContingencyPlan" && (
                  <ModalBody>
                    <div className="">
                      <div className="nk-modal-head">
                        <h5 className="title">
                          Edit Emergency Response and Contingency Plans
                        </h5>
                      </div>
                      <div className="nk-tnx-details mt-sm-3">
                        <FormProvider {...methods}>
                          <form
                            className="content clearfix"
                            onSubmit={handleSubmit(submitUpdates)}
                          >
                            <Row className="gy-4">
                              <Col md="6">
                                <FormInput
                                  name="emergencyContactPerson"
                                  label="Contact Person"
                                  type="text"
                                  placeholder="Enter Contact Person"
                                  // disabled={action === "view"}
                                />
                              </Col>
                              <Col md="6">
                                <FormInput
                                  name="emergencyContactNumber"
                                  // disabled={action === "view"}
                                  label="Contact Number"
                                  type="number"
                                  placeholder="Enter Contact Information"
                                  // pattern={/^(?:(\+91)?[\-\s]?)?[6-9]\d{9}$/}
                                />
                              </Col>
                              <Col md="6">
                                <FormInput
                                  name="emergencyProcedures"
                                  label="Upload Emergency Procedures"
                                  // disabled={action === "view"}
                                  type="file"
                                  placeholder="Upload Emergency Procedures"
                                />
                                {/* {emergencyProceduresWatch && (
                                <div>{emergencyProceduresWatch[0]?.name}</div>
                              )} */}
                                {docs
                                  .filter(
                                    (doc) =>
                                      doc.moduleFileType ===
                                      "emergencyProcedures"
                                  )
                                  .map((doc) => (
                                    <div key={doc.docId}>
                                      <a
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {doc.fileName}
                                      </a>
                                    </div>
                                  ))}
                              </Col>
                            </Row>
                            <Row className="gy-4 mt-1">
                              <Col size="12">
                                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                  <li>
                                    <Button
                                      color="primary"
                                      size="lg"
                                      // onClick={() => submitForm()}
                                    >
                                      Update
                                    </Button>
                                  </li>
                                  <li>
                                    <a
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setGIModal(false);
                                      }}
                                      className="link link-light"
                                    >
                                      Cancel
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </form>
                        </FormProvider>
                      </div>
                    </div>
                  </ModalBody>
                )}

                {modalEditBlockName === "contractorInformation" && (
                  <ModalBody>
                    <div className="">
                      <div className="nk-modal-head">
                        <h5 className="title">Edit General Information </h5>
                      </div>
                      <div className="nk-tnx-details mt-sm-3">
                        <FormProvider {...methods}>
                          <form
                            className="content clearfix"
                            onSubmit={handleSubmit(submitUpdates)}
                          >
                            <Row className="gy-4">
                              <Col md="3">
                                <FormInput
                                  name="referenceID"
                                  label="Client ID"
                                  required={true}
                                  disabled={true}
                                  // maxLength={10}
                                  type="text"
                                  pattern={/^[a-zA-Z0-9./_-]+$/}
                                  placeholder="Enter Client ID"
                                />
                              </Col>
                              <Col md="3">
                                <FormSelect
                                  name="contractorType"
                                  label="Client Type"
                                  required={true}
                                  options={[
                                    {
                                      label: "General Contractor",
                                      value: "General Contractor",
                                    },
                                    {
                                      label: "Sub Contractor",
                                      value: "Sub Contractor",
                                    },
                                    {
                                      label: "Self Construction",
                                      value: "Self Construction",
                                    },
                                  ]}
                                  placeholder="Enter Client Terms"
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="companyName"
                                  label="Client Name"
                                  required={true}
                                  placeholder="Enter Client Name"
                                  // pattern={/^[A-Za-z\s]+$/}
                                  // onInput={(e: any) => {
                                  //   e.target.value = e.target.value.replace(
                                  //     /[^A-Za-z\s]/g,
                                  //     ""
                                  //   );
                                  // }}
                                  pattern={/^[a-zA-Z0-9\s&.,'-]+$/}
                                  onInput={(e: any) => {
                                    e.target.value = e.target.value.replace(
                                      /[^a-zA-Z0-9\s&.,'-]/g,
                                      ""
                                    );
                                  }}
                                  // disabled={businessType === "registered"}
                                  disabled
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="contactPerson"
                                  // disabled={action === "view"}
                                  label="Contact Person"
                                  required={true}
                                  type="text"
                                  maxLength={50}
                                  placeholder="Enter Contact Person"
                                />
                              </Col>
                              <Col md="3">
                                <FormMultiSelect
                                  name="siteAccessibility"
                                  label="Site Accessibility"
                                  required={true}
                                  options={workingSites}
                                  placeholder="Select Site Accessibility"
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="email"
                                  // disabled={action === "view"}
                                  required={true}
                                  label="Email"
                                  type="email"
                                  placeholder="Enter Email"
                                  // pattern={
                                  //   /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/
                                  // }
                                  disabled
                                />
                              </Col>
                              <Col md="3">
                                <PhoneNumberInput
                                  name="phoneNumber"
                                  required={true}
                                />
                              </Col>
                              <Col md="3">
                                <FormSelect
                                  name="country"
                                  label="Country"
                                  options={countries}
                                  required={true}
                                  placeholder="-Select-"
                                  onChange={(e) => {
                                    fetchStatesByCountry(e);
                                  }}
                                />
                              </Col>
                              <Col md="3">
                                <FormSelect
                                  name="state"
                                  label="State"
                                  required={true}
                                  options={states}
                                  placeholder="Select State"
                                />
                              </Col>
                              <Col md="3">
                                <FormSelect
                                  name="district"
                                  label="District"
                                  options={districtOptions}
                                  required={true}
                                  placeholder="Select District"
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="city"
                                  label="City"
                                  required={true}
                                  // disabled={action === "view"}
                                  placeholder="Enter City"
                                  type="text"
                                />
                              </Col>
                              <Col lg="3">
                                <FormInput
                                  name="area"
                                  // disabled={action === "view"}
                                  label="Area"
                                  required={true}
                                  placeholder="Enter Area"
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="mailingAddressLine1"
                                  // disabled={action === "view"}
                                  label="Address Line 1"
                                  // required={true}
                                  placeholder="Enter Area"
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="pincode"
                                  // disabled={action === "view"}
                                  label="Zip/Pincode"
                                  required={true}
                                  type="text"
                                  pattern={/^\d+$/} // Allows only digits
                                  onInput={(e: any) => {
                                    e.target.value = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    ); // Removes non-numeric characters
                                  }}
                                  placeholder="Enter Zip or pin code"
                                />
                              </Col>
                              <Col md="3">
                                <FormInput
                                  name="yearsInBusiness"
                                  // disabled={action === "view"}
                                  label="Years in Business"
                                  type="text"
                                  placeholder="Enter Years in Business"
                                  pattern={/^\d+$/} // Allows only digits
                                  onInput={(e: any) => {
                                    e.target.value = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    ); // Removes non-numeric characters
                                  }}
                                />
                              </Col>
                              {/* <Col md="3">
                              <FormInput
                                name="references"
                                label="References"
                                type="text"
                                // disabled={action === "view"}
                                placeholder="Enter References"
                              />
                            </Col> */}

                              <Col md="12">
                                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                  <li>
                                    <Button
                                      color="primary"
                                      size="lg"
                                      type="submit"
                                      // onClick={() => submitForm()}
                                    >
                                      Update
                                    </Button>
                                  </li>
                                  <li>
                                    <a
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setGIModal(false);
                                      }}
                                      className="link link-light"
                                    >
                                      Cancel
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </form>
                        </FormProvider>
                      </div>
                    </div>
                  </ModalBody>
                )}

                {modalEditBlockName === "contractorProfile" && (
                  <ModalBody>
                    <div className="">
                      <div className="nk-modal-head">
                        <h5 className="title">Edit Legal Information </h5>
                      </div>
                      <div className="nk-tnx-details mt-sm-3">
                        <FormProvider {...methods}>
                          <form
                            className="content clearfix"
                            onSubmit={handleSubmit(submitUpdates)}
                          >
                            <Row className="gy-4">
                              <Col md="6">
                                <div className="form-group">
                                  <FormSelect
                                    name="bussinessType"
                                    label="Business Type"
                                    options={[
                                      {
                                        label: "Registered",
                                        value: "registered",
                                      },
                                      {
                                        label: "UnRegistered",
                                        value: "unregistered",
                                      },
                                    ]}
                                    disabled={
                                      data.bussinessType === "registered"
                                    }
                                    onChange={(value) => {
                                      if (
                                        value === "registered" &&
                                        previousBusinessType === "unregistered"
                                      ) {
                                        setGstinModal(true);
                                        setValue("bussinessType", value);
                                      } else {
                                        setValue("bussinessType", value);
                                      }
                                    }}
                                    // defaultValue={data.businessType}
                                  />
                                  {businessType === "registered" &&
                                    !isGstVerified && (
                                      <div className="text-danger mt-1">
                                        Please upload GST file to proceed with
                                        registration.
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="form-group">
                                  <FormInput
                                    name="cin"
                                    label="CIN"
                                    type="text"
                                    placeholder="Enter pan"
                                    disabled={
                                      data.bussinessType === "registered" &&
                                      !isGstVerified
                                    }
                                  />
                                </div>
                              </Col>

                              {businessType == "registered" && (
                                <>
                                  <Col md="6">
                                    <div className="form-group">
                                      <FormInput
                                        type="text"
                                        label="GSTIN"
                                        // disabled={formData.gstin}
                                        required={true}
                                        name="gstin"
                                        placeholder="Enter GSTIN"
                                        // pattern={
                                        //   /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/
                                        // }
                                        maxLength={15}
                                        pattern={
                                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}Z[0-9A-Z]{1}$/
                                        }
                                        disabled={
                                          !isGstVerified
                                          // && data.bussinessType === "registered"
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md="6">
                                    <div className="form-group">
                                      <FormDatePicker
                                        name="incorporationDate"
                                        label="Incorporation Date"
                                        required
                                        disabled={
                                          !isGstVerified
                                          // data.bussinessType === "registered"
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md="6">
                                    <div className="form-group">
                                      <FormInput
                                        type="text"
                                        label="PAN"
                                        // disabled={formData.pan}
                                        required={true}
                                        name="pan"
                                        placeholder="Enter pan"
                                        disabled={
                                          !isGstVerified ||
                                          data.bussinessType === "registered"
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col md="6">
                                    <div className="form-group">
                                      <FormInput
                                        type="number"
                                        label="Last FY Turn over"
                                        name="lastFYTurnover"
                                        // defaultValue={formData.lastFYTurnover}
                                        placeholder="Enter Last FY Turn over"
                                      />
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                            <Row className="gy-4 mt-1">
                              <Col size="12">
                                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                  <li>
                                    <Button
                                      color="primary"
                                      size="lg"
                                      // onClick={() => submitForm()}
                                    >
                                      Update
                                    </Button>
                                  </li>
                                  <li>
                                    <a
                                      href="#dropdownitem"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setGIModal(false);
                                      }}
                                      className="link link-light"
                                    >
                                      Cancel
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </form>
                        </FormProvider>
                      </div>
                    </div>
                  </ModalBody>
                )}
              </Modal>
            </>
          )}
        </Content>
      </React.Fragment>

      <GstinVerificationModal
        isOpen={gstinModal}
        toggle={() => setGstinModal(!gstinModal)}
        onVerified={(gstData: any) => {
          console.log("Verified GST Data:", gstData);

          // Parse the date with correct format
          const parseDate = (dateString: string) => {
            if (!dateString) return null;
            // Handle DD/MM/YYYY format
            if (dateString.includes("/")) {
              const [day, month, year] = dateString.split("/");
              return dayjs(`${year}-${month}-${day}`);
            }
            return dayjs(dateString);
          };
          // Set values with validation
          setValue("gstin", gstData.gstin, { shouldValidate: true });
          setValue("pan", gstData.pan, { shouldValidate: true });
          setValue("companyName", gstData.LegalName, {
            shouldValidate: true,
          });

          // Find country ID by name
          const country = countries.find((c) => c.label === gstData.country);
          if (country) {
            setValue("country", country.value, { shouldValidate: true });
          }

          // Find state ID by name
          const state = states.find((s) => s.label === gstData.state);
          if (state) {
            setValue("state", state.value, { shouldValidate: true });
          }

          setValue(
            "incorporationDate",
            gstData.incorporationDate
              ? parseDate(gstData.incorporationDate)
              : null,
            { shouldValidate: true }
          );

          // Find district ID by name
          const district = districtOptions.find(
            (d) => d.label === gstData.district
          );
          if (district) {
            setValue("district", district.value, { shouldValidate: true });
          }

          setValue("city", gstData.city, { shouldValidate: true });
          setValue("area", gstData.area, { shouldValidate: true });
          setValue("mailingAddressLine1", gstData.addressLine1, {
            shouldValidate: true,
          });
          setValue("pincode", gstData.zipPincode, { shouldValidate: true });

          setIsGstVerified(true);
          setGstinModal(false);

          // Trigger validation
          setTimeout(() => {
            trigger();
          }, 100);
        }}
        countries={countries}
        states={states}
        districts={districtOptions}
      />
    </>
  );
};

export default ViewClientDetails;

